import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1702276103001'
        className='icon'
        viewBox='0 0 1181 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='17333'
    >
        <path
            d='M30.48448 0.787692c183.926154 47.340308 371.948308 56.871385 560.600615 56.871385 187.392 0 374.705231-6.774154 559.340308-56.241231A24.654769 24.654769 0 0 1 1181.539249 25.206154c-0.630154 259.150769-0.630154 514.756923-0.630154 769.024 0.078769 14.966154-14.178462 26.387692-29.696 23.709538-374.705231-76.406154-747.362462-74.358154-1121.437538 0.708923a24.733538 24.733538 0 0 1-29.774769-24.418461V24.497231C0.000788 8.270769 14.966942-3.150769 30.48448 0.787692zM473.403865 347.214769v150.212923c0 37.179077 39.936 60.258462 72.388923 41.905231 43.874462-25.048615 87.985231-50.097231 132.489846-75.854769a48.049231 48.049231 0 0 0-0.630154-83.810462l-132.489846-74.358154a47.891692 47.891692 0 0 0-71.758769 41.905231z'
            fill='#FD6E42'
            p-id='17334'
        ></path>
        <path
            d='M980.047557 1012.736H202.280172a47.025231 47.025231 0 0 1-47.340307-47.261538c0-26.466462 20.952615-47.419077 47.261538-47.419077h777.846154c26.387692 0 47.340308 20.952615 47.340308 47.340307a47.025231 47.025231 0 0 1-47.261539 47.340308z'
            fill='currentColor'
        ></path>
    </svg>
)

export const POMSIcon = props => <Icon component={SVG} {...props} />
